import { createInterfaceId, Injectable } from '@gitlab-org/di';
import { URI } from 'vscode-uri';

export interface ReadFile {
  fileUri: URI;
}

export interface FileResolver {
  readFile(_args: ReadFile): Promise<string>;
}

export const FileResolver = createInterfaceId<FileResolver>('FileResolver');

@Injectable(FileResolver, [])
export class EmptyFileResolver {
  // FIXME: deprecate this class and move logic to use the fs.ts class
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  readFile(_args: ReadFile): Promise<string> {
    return Promise.resolve('');
  }
}
